import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";

const EMOJIS = [
  "😀",
  "😁",
  "😂",
  "😃",
  "😄",
  "😅",
  "😆",
  "😇",
  "😈",
  "😉",
  "😊",
  "😋",
  "😌",
  "😍",
  "😎",
  "😏",
  "😐",
  "😑",
  "😒",
  "😓",
  "😔",
  "😕",
  "😖",
  "😗",
  "😘",
  "😙",
  "😚",
  "😛",
  "😜",
  "😝",
  "😞",
  "😟",
  "😠",
  "😡",
  "😢",
  "😣",
  "😤",
  "😥",
  "😦",
  "😧",
  "😨",
  "😩",
  "😪",
  "😫",
  "😬",
  "😭",
  "😮",
  "😯",
  "😰",
  "😱",
  "😲",
  "😳",
  "😴",
  "😵",
  "😶",
  "😷",
];

const ToolbarEmoji = () => {
  const { editor } = useEditorContext();
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const handleSelect = (emoji) => {
    editor.chain().focus().insertContent(emoji).run();

    toggle();
  };

  return (
    <>
      <ToolbarItem
        id={`emoji-toolbar-item`}
        tooltip={`Emoji beszúrása`}
        active={false}
        onToggle={toggle}
        icon={<i className="fa fa-face-laugh-beam" aria-hidden="true" />}
      />

      <Modal isOpen={modal} toggle={toggle} backdrop="static">
        <ModalHeader toggle={toggle}>Emoji beszúrása</ModalHeader>
        <ModalBody
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(8, 1fr)",
            gap: "4px",
          }}
        >
          {EMOJIS.map((emoji, idx) => (
            <Button
              key={idx}
              onClick={() => handleSelect(emoji)}
              style={{ fontSize: "24px", padding: 0 }}
            >
              {emoji}
            </Button>
          ))}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Mégsem
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ToolbarEmoji;
